// The webshop's static-data `temporaryItems` doesn't carry event-token expiries, so a
// temporary token falls back to its pack's endAt, which for most event packs is the
// event's finishAt (the smart-pack trigger copies it over).
//
// Sections listed here rotate daily instead: their trigger has `dayChangeClaim`, which
// clamps endAt to min(event finishAt, end of today) (PlayerStore.processTriggers in
// hmmo-backend). That date would show a token expiring at midnight while it lasts until
// the event ends, so these packs show no expiry at all.
const DAILY_ROTATION_SECTIONS = ['singleJackFever'];

export function tokenExpiryFallback(storePack) {
    if (!storePack || DAILY_ROTATION_SECTIONS.includes(storePack.storeSection)) return undefined;
    return storePack.endAt;
}
